<div class="page">
    <div class="container">
        <div class="top_area">
            <div class="row flex_top row_jc_space_btw">
                <ul class="tabs row fz_s">
                    <li class="tab"><a routerLink="list" routerLinkActive="link_active" class="link row row_ai_center">
                        <span class="material-symbols-outlined">
                            assignment
                        </span>
                        Все задачи</a></li>
                    <li class="tab"><a routerLink="123" routerLinkActive="link_active" class="link row row_ai_center">
                        <span class="material-symbols-outlined">
                            article_person
                        </span>
                        Мои задачи</a></li>
                </ul>
                <div class="item create_task row row_ai_center">
                    <app-filter-btn></app-filter-btn>
                    <button type="button" class="btn dark_btn row fz_s fw_500">Создать задачу <span
                            class="material-symbols-outlined fz_m">
                            add</span></button>
                </div>
            </div>
            <app-filter *ngIf="false">
                <app-filter-order></app-filter-order>
            </app-filter>
        </div>
        <router-outlet></router-outlet>
    </div>
</div>
